import { useEffect } from "react";
import { useMap } from "react-leaflet";

// Helper to recenter map when coords change
export default function MapRecenter({ lat, lon }) {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lon], map.getZoom());
  }, [lat, lon, map]);
  return null;
}
